import { HotelInventory } from '@apps/admin/routes/Planning/hooks/HotelListSearcher/useZentrumHubHotelListSearcher';
import { EventDesignFragment } from '@graphql/generated';
import { createContext, useContext } from 'react';

export interface DeleteComponentDetails {
  id: string;
  title: string;
  subTitle: string;
  deleteCta: string;
  cancelCta: string;
  successMessage: string;
  errorMessage: string;
  type?: string;
}

export interface BlockOrderData {
  id: string;
  sortOrder: number;
  blockOrdering: string[];
}

export type CustomComponentStateBlockBaseProps = {};

/**
 * While navigate screens(list, add, edit) in custom page editor left panel, we need to handle state between each screen
 * customComponentBlockData - Handled state for CustomComponents like TravelMap, Travel, Photo etc, Also handled state for CustomComponents blocks like RoomBlock, Hotel, Custom etc.
 * blockOrderData - To persist sort order state of nested items of active CustomComponent
 */
export interface CustomComponentStateContextProps<T extends CustomComponentStateBlockBaseProps> {
  eventDesign?: EventDesignFragment;
  blockOrderData?: BlockOrderData;
  customComponentBlockData?: T;
  showDeletePopup: boolean;
  refetchQueries: string[];
  deleteComponentDetails?: DeleteComponentDetails;
  matchedHotel?: HotelInventory | null;
  selectedHotelPhotos?: { url: string }[] | null;
  setSelectedHotelPhotos: (hotelPhotos: { url: string }[] | null) => void;
  setMatchedHotel: (hotel: HotelInventory | null) => void;
  setDeleteComponentDetails: (deleteDialogDetails?: DeleteComponentDetails) => void;
  setBlockOrderData: (blockOrderData?: BlockOrderData) => void;
  setCustomComponentBlockData: (data: T) => void;
  setShowDeletePopup: (showDeletePopup: boolean) => void;
  setRefetchQueries: (refetchQueries: string[]) => void;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const CustomComponentStateContext = createContext<CustomComponentStateContextProps<any> | undefined>(undefined);

export const useCustomComponentStateContext = <T extends CustomComponentStateBlockBaseProps>(): CustomComponentStateContextProps<T> => {
  const context = useContext(CustomComponentStateContext) as CustomComponentStateContextProps<T> | undefined;
  if (!context) {
    throw new Error('useCustomComponentStateContext must be used within an CustomComponentStateProvider');
  }
  return context;
};
